const TYPES = {
  IFluoroCurveControllerFactory: Symbol.for('IFluoroCurveController')
};

export { TYPES };
